import { render } from "./ReservationHero.vue?vue&type=template&id=6284f650&scoped=true"
const script = {}

import "./ReservationHero.vue?vue&type=style&index=0&id=6284f650&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6284f650"]])

export default __exports__